import script from "./CallControlPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallControlPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CallControlPanel.vue?vue&type=style&index=0&id=1969f753&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1969f753"]])

export default __exports__